export const REDUCER_NAME = 'gameLoader';

const ACTION_PREFIX = '@komigen/gameLoader';
export const CLEAN_UP = `${ACTION_PREFIX}/CLEAN_UP`;
export const SET_CURRENT_GAME = `${ACTION_PREFIX}/SET_CURRENT_GAME`;
export const SET_GAME_LOADER_RESPONSE = `${ACTION_PREFIX}/SET_GAME_LOADER_RESPONSE`;
export const SET_GAME_LOADER_REQUEST_PENDING = `${ACTION_PREFIX}/SET_GAME_LOADER_REQUEST_PENDING`;
export const SET_CLEANUP_LISTENERS = `${ACTION_PREFIX}/SET_CLEANUP_LISTENERS`;
export const SET_LOAD_AS = `${ACTION_PREFIX}/SET_LOAD_AS`;
export const SET_GAME_MODE = `${ACTION_PREFIX}/SET_GAME_MODE`;
export const SET_MOBILE_TOOLBAR_BUTTONS = `${ACTION_PREFIX}/SET_MOBILE_TOOLBAR_BUTTONS`;
